import { render } from "./TheNavbar.vue?vue&type=template&id=83231596"
import script from "./TheNavbar.vue?vue&type=script&lang=js"
export * from "./TheNavbar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\reimo\\Documents\\Projektide IT osa\\AccountaBuddy\\accounta-buddy-app-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__